import { useClientPortalAPI, useRequest } from "@certn/api";
import {
  Modal,
  Dialog,
  DialogHeader,
  DialogContent,
  DialogFooter,
  BasicButton,
  Text,
  PrimaryButton,
} from "@certn/cascadia-react";
import { useTranslation, Trans } from "react-i18next";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  tagName: string;
  id: string;
}
export function ReactivateTagModal(props: Props) {
  const { t } = useTranslation();
  const { isOpen, onClose, tagName, id } = props;

  const request = useRequest();
  const { mutate } = useClientPortalAPI(`/api/internal/client-portal/tags/`);

  async function activateTag(): Promise<void> {
    await request(`/api/internal/client-portal/tags/${id}/activate/`, {
      method: "POST",
    });
    mutate();
    onClose();
  }
  return (
    <Modal isOpen={isOpen}>
      <Dialog>
        <DialogHeader onClose={onClose}>{t("Reactivate tag?")}</DialogHeader>
        <DialogContent>
          <Text style="global/body-primary">
            <Trans>
              By clicking “Reactivate tag”, the {{ tagName }} label will be made
              available to be used.
            </Trans>
          </Text>
        </DialogContent>
        <DialogFooter>
          <BasicButton onPress={onClose}>{t("Cancel")}</BasicButton>
          <PrimaryButton onPress={() => activateTag()}>
            {t("Reactivate tag")}
          </PrimaryButton>
        </DialogFooter>
      </Dialog>
    </Modal>
  );
}
